module.exports = __webpack_public_path__ + "assets/43c7b049ac74072dbf13802d3367e693.mp4";